import script from "./BackHome.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackHome.vue?vue&type=script&lang=ts&setup=true"

import "./BackHome.vue?vue&type=style&index=0&id=7d8432c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8432c7"]])

export default __exports__